<template>
  <div v-if="initPage">
    <div v-loading="true" class="loading"></div>
  </div>
  <div v-else>
    <el-row type="flex" justify="space-between">
      <el-col :span="24">
        <span style="margin-right: 10px;">{{
          $t("assignoperators.topRow.userCode")
        }}</span>
        <currency-input
          placeholder=""
          v-model="operatorForm.userCodeCode"
          @blur="onChangeUserCodeCode"
          @keyup.enter.native="onChangeUserCodeCode"
          :precision="0"
          class="el-input--small el-input__inner"
          style="width: 55px; height: 32px; line-height: 32px; margin-right: 5px"
        />
        <el-select
          v-model="operatorForm.userCode"
          :placeholder="$t('common.components.select.placeholder')"
          clearable
          filterable
          size="small"
          style="width: 280px; margin-right: 15px;"
          :loading="operatorsLoading"
        >
          <el-option
            v-for="item in operators.data"
            :key="item.userid"
            :label="item.fio"
            :value="item.userid"
          ></el-option>
        </el-select>
        <el-checkbox
          v-model="operatorForm.workedEnabled"
          style="margin-right: 10px;"
          >{{ $t("assignoperators.topRow.worked") }}</el-checkbox
        >
        <el-date-picker
          v-model="operatorForm.workedDate"
          type="date"
          :placeholder="$t('common.components.datePicker.placeholder')"
          format="dd.MM.yyyy"
          value-format="dd.MM.yyyy"
          :picker-options="pickerOptions"
          :disabled="!operatorForm.workedEnabled"
          :clearable="false"
          style="margin-right: 15px;"
        ></el-date-picker>
        <el-checkbox
          v-model="operatorForm.positionEnabled"
          style="margin-right: 10px;"
          >{{ $t("assignoperators.topRow.onPositions") }}</el-checkbox
        >
        <el-select
          v-model="operatorForm.positionCode"
          :placeholder="$t('common.components.select.placeholder')"
          filterable
          :disabled="!operatorForm.positionEnabled"
          size="small"
          style="width: 260px;"
        >
          <el-option
            v-for="item in params.position.data"
            :key="item.codepost"
            :label="item.name"
            :value="item.codepost"
          ></el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row type="flex" justify="space-between">
      <el-col :span="24" class="grid-container-operators">
        <ag-grid-vue
          style="width: 100%; height: 100%; text-align: center; font-family: 'Open Sans', sans-serif;"
          class="ag-theme-balham"
          rowSelection="single"
          :columnDefs="freePacksColumnDefs"
          :rowData="freePacks"
          :defaultColDef="defaultColDef"
          :gridOptions="freePacksGridOptions"
          :modules="agGridModules"
          @grid-ready="onFreePacksGridReady"
          @first-data-rendered="onFreePacksFirstDataRendered"
          @gridSizeChanged="onGridSizeChanged"
          @modelUpdated="onFreePacksModelUpdated"
          @rowSelected="onFreePacksRowSelected"
          @cellContextMenu="onFreePacksRowRightClicked"
        ></ag-grid-vue>
      </el-col>
    </el-row>
    <el-row type="flex" justify="space-between" style="margin-top: 10px">
      <el-col :span="22">
        <el-button
          type="primary"
          size="small"
          :disabled="assignBtnDisabled"
          @click="assignBtn"
          v-shortkey="{ Insert: ['insert'], Plus: ['+'] }"
          @shortkey.native="onShortKeyRouter"
          ><span class="key-name">Ins</span
          >{{ $t("common.buttons.assign") }}</el-button
        >
      </el-col>
    </el-row>
    <el-row type="flex" justify="space-between">
      <el-col :span="24" class="grid-container-operators">
        <ag-grid-vue
          style="width: 100%; height: 100%; text-align: center; font-family: 'Open Sans', sans-serif;"
          class="ag-theme-balham"
          rowSelection="single"
          :columnDefs="assignedPacksColumnDefs"
          :rowData="assignedPacks"
          :defaultColDef="defaultColDef"
          :gridOptions="assignedPacksGridOptions"
          :modules="agGridModules"
          @grid-ready="onAssignedPacksGridReady"
          @first-data-rendered="onAssignedPacksFirstDataRendered"
          @gridSizeChanged="onGridSizeChanged"
          @modelUpdated="onAssignedPacksModelUpdated"
          @rowSelected="onAssignedPacksRowSelected"
          @cellContextMenu="onAssignedPacksRowRightClicked"
        ></ag-grid-vue>
      </el-col>
    </el-row>
    <el-row type="flex" justify="space-between" style="margin-top: 10px">
      <el-col :span="24">
        <el-button
          type="primary"
          size="small"
          :disabled="unassignBtnDisabled"
          @click="unassignBtn"
          v-shortkey="{ Del: ['del'], Minus: ['-'] }"
          @shortkey.native="onShortKeyRouter"
          ><span class="key-name">Del</span
          >{{ $t("common.buttons.unassign") }}</el-button
        >
        <el-button
          type="primary"
          size="small"
          :disabled="receiptsBtnDisabled"
          @click="receiptsBtn"
          v-shortkey="{ Enter: ['enter'], F9: ['f9'] }"
          @shortkey.native="onShortKeyRouter"
          ><span class="key-name">F9</span
          >{{ $t("common.buttons.receipts") }}</el-button
        >
      </el-col>
    </el-row>

    <el-dialog
      :title="$t('assignoperators.receipts.modal.title')"
      :visible.sync="receiptsModal"
      :close-on-click-modal="false"
      @open="receiptsModalShow"
      @close="receiptsModalHide"
      fullscreen
    >
      <el-form :model="receiptsForm">
        <el-row type="flex" justify="space-between">
          <el-col :span="7">
            <el-form-item
              :label="$t('assignoperators.receipts.form.summa.title')"
              label-width="120px"
            >
              <currency-input
                placeholder="0.00"
                v-model.lazy="receiptsForm.summa"
                :disabled="true"
                class="el-input--small el-input__inner moneydisable"
                style="width: 100%; height: 36px; line-height: 36px;"
              />
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item
              :label="$t('assignoperators.receipts.form.datebank.title')"
              label-width="120px"
            >
              <el-date-picker
                v-model="receiptsForm.datebank"
                type="date"
                :placeholder="$t('common.components.datePicker.placeholder')"
                format="dd.MM.yyyy"
                value-format="dd.MM.yyyy"
                :picker-options="pickerOptions"
                size="small"
                style="width: 100%"
                disabled
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="10"></el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="7">
            <el-form-item
              :label="$t('assignoperators.receipts.form.quantity.title')"
              label-width="120px"
            >
              <el-input
                v-model="receiptsForm.quantity"
                style="width: 100%;"
                size="small"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item
              :label="$t('assignoperators.receipts.form.countband.title')"
              label-width="120px"
            >
              <el-input
                v-model="receiptsForm.countband"
                style="width: 100%;"
                size="small"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              v-if="receiptsForm.reasonname"
              :label="$t('assignoperators.receipts.form.reasonname.title')"
              label-width="140px"
            >
              <el-input
                v-model="receiptsForm.reasonname"
                style="width: 100%;"
                size="small"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2"></el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="6" class="grid-container-modalinfopacks">
            <ag-grid-vue
              style="width: 100%; height: 100%; text-align: center; font-family: 'Open Sans', sans-serif;"
              class="ag-theme-balham"
              rowSelection="single"
              :columnDefs="packsCountbandColumnDefs"
              :rowData="packsCountband"
              :defaultColDef="defaultColDef"
              :gridOptions="packsCountbandGridOptions"
              :modules="agGridModules"
              :getRowStyle="packsGetRowStyle"
              :pinnedBottomRowData="packsCountbandPinnedBottomRowData"
              @grid-ready="onPacksCountbandGridReady"
              @first-data-rendered="onPacksCountbandFirstDataRendered"
              @gridSizeChanged="onGridSizeChanged"
              @modelUpdated="onPacksCountbandModelUpdated"
              @rowSelected="onPacksCountbandRowSelected"
              @cellContextMenu="onPacksCountbandRowRightClicked"
            ></ag-grid-vue>
          </el-col>
          <el-col :span="18" class="grid-container-modalinfopacks">
            <ag-grid-vue
              style="width: 100%; height: 100%; text-align: center; font-family: 'Open Sans', sans-serif;"
              class="ag-theme-balham"
              rowSelection="single"
              :columnDefs="packsQuantityColumnDefs"
              :rowData="packsQuantity"
              :defaultColDef="defaultColDef"
              :gridOptions="packsQuantityGridOptions"
              :modules="agGridModules"
              :getRowStyle="packsGetRowStyle"
              :pinnedBottomRowData="packsQuantityPinnedBottomRowData"
              @grid-ready="onPacksQuantityGridReady"
              @first-data-rendered="onPacksQuantityFirstDataRendered"
              @gridSizeChanged="onGridSizeChanged"
              @modelUpdated="onPacksQuantityModelUpdated"
              @rowSelected="onPacksQuantityRowSelected"
              @cellContextMenu="onPacksQuantityRowRightClicked"
            ></ag-grid-vue>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-row type="flex" justify="space-between">
          <el-col :span="12" style="text-align:left;">
            <div v-if="infoPackReceiptsBtnContainer">
              <el-button
                type="primary"
                size="small"
                @click="receiptsModalSubmit"
                :disabled="infoPackReceiptsBtnDisabled"
                v-shortkey="{ F9: ['f9'] }"
                @shortkey.native="onShortKeyRouter"
                ><span class="key-name">F9</span
                >{{ $t("common.buttons.posting") }}</el-button
              >
            </div>
          </el-col>
          <el-col :span="12" style="text-align:right;">
            <el-button type="plain" size="small" @click="receiptsModal = false"
              ><span class="key-name">Esc</span
              >{{ $t("common.buttons.close") }}</el-button
            >
          </el-col>
        </el-row>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { userName, reasonName, sortSum, formatSum } from "@/helpers/reference";
import { mapActions, mapGetters } from "vuex";
import { AgGridVue } from "ag-grid-vue";
import { AllCommunityModules } from "@ag-grid-community/all-modules";
import agGridLocaleRu from "@/locales/ru/agGrid";
import agGridLocaleUa from "@/locales/ua/agGrid";
import agGridLocaleEn from "@/locales/en/agGrid";
import i18n from "@/locales";
import { $ } from "moneysafe";
import { setGridView } from "@/helpers/grid";
import { pickerOptions } from "@/mixins/pickerOptions";
import { checkAccess } from "@/helpers/access";

export default {
  name: "assignoperators",
  components: {
    AgGridVue
  },
  mixins: [pickerOptions],
  data() {
    return {
      agGridModules: AllCommunityModules,
      agGridlocaleText: null,
      freePacksGridOptions: null,
      freePacksGridApi: null,
      freePacksColumnApi: null,
      assignedPacksGridOptions: null,
      assignedPacksGridApi: null,
      assignedPacksColumnApi: null,
      packsCountbandGridOptions: null,
      packsCountbandGridApi: null,
      packsCountbandColumnApi: null,
      packsQuantityGridOptions: null,
      packsQuantityGridApi: null,
      packsQuantityColumnApi: null,
      packsGetRowStyle: null,
      packsCountbandPinnedBottomRowData: null,
      packsQuantityPinnedBottomRowData: null,
      defaultColDef: {
        resizable: true,
        sortable: true,
        filter: true,
        autoHeight: false,
        filterParams: {
          applyButton: false,
          clearButton: true
        },
        headerClass: "ag-grid-header",
        cellClass: "ag-grid-cell"
      },
      freePacksColumnDefs: [
        {
          headerName: this.$t(
            "assignoperators.freePacksColumn.headers.freePacks"
          ),
          headerTooltip: this.$t(
            "assignoperators.freePacksColumn.headers.freePacks"
          ),
          children: [
            {
              headerName: this.$t("common.gridColumns.namefirmeSender"),
              headerTooltip: this.$t("common.gridColumns.namefirmeSender"),
              field: "namefirme",
              tooltipField: "namefirme"
            },
            {
              headerName: this.$t("common.gridColumns.summa"),
              headerTooltip: this.$t("common.gridColumns.summa"),
              field: "summa",
              tooltipField: "summa",
              cellClass: "sum-column",
              valueFormatter: params => formatSum(params.value),
              comparator: (sum1, sum2) => sortSum(sum1, sum2)
            },
            {
              headerName: this.$t("common.gridColumns.datebank"),
              headerTooltip: this.$t("common.gridColumns.datebank"),
              field: "datebank",
              tooltipField: "datebank",
              comparator: (date1, date2) =>
                parseInt(this.$moment(date1, "DD.MM.YYYY").unix()) -
                parseInt(this.$moment(date2, "DD.MM.YYYY").unix())
            },
            {
              headerName: this.$t("common.gridColumns.kindname"),
              headerTooltip: this.$t("common.gridColumns.kindname"),
              field: "kindname",
              tooltipField: "kindname"
            },
            {
              headerName: this.$t("common.gridColumns.quantity"),
              headerTooltip: this.$t("common.gridColumns.quantity"),
              field: "quantity",
              tooltipField: "quantity",
              comparator: (value1, value2) =>
                parseInt(value1) - parseInt(value2)
            },
            {
              headerName: this.$t("common.gridColumns.countband"),
              headerTooltip: this.$t("common.gridColumns.countband"),
              field: "countband",
              tooltipField: "countband",
              comparator: (value1, value2) =>
                parseInt(value1) - parseInt(value2)
            },
            {
              headerName: this.$t("common.gridColumns.sumprof"),
              headerTooltip: this.$t("common.gridColumns.sumprof"),
              field: "sumprof",
              tooltipField: "sumprof",
              cellClass: "sum-column",
              valueFormatter: params => formatSum(params.value),
              comparator: (sum1, sum2) => sortSum(sum1, sum2)
            },
            {
              headerName: this.$t("common.gridColumns.statusname"),
              headerTooltip: this.$t("common.gridColumns.statusname"),
              field: "statusname"
            },
            {
              headerName: this.$t("common.gridColumns.packnumber"),
              headerTooltip: this.$t("common.gridColumns.packnumber"),
              field: "packnumber",
              tooltipField: "packnumber"
            },
            {
              headerName: this.$t("common.gridColumns.sumwithoutprof"),
              headerTooltip: this.$t("common.gridColumns.sumwithoutprof"),
              field: "summawithout",
              tooltipField: "summawithout",
              cellClass: "sum-column",
              valueFormatter: params => formatSum(params.value),
              comparator: (sum1, sum2) => sortSum(sum1, sum2)
            }
          ]
        }
      ],
      assignedPacksColumnDefs: [
        {
          headerName: this.$t(
            "assignoperators.assignedPacksColumn.headers.assignedPacks"
          ),
          headerTooltip: this.$t(
            "assignoperators.assignedPacksColumn.headers.assignedPacks"
          ),
          children: [
            {
              headerName: this.$t("common.gridColumns.namefirmeSender"),
              headerTooltip: this.$t("common.gridColumns.namefirmeSender"),
              field: "namefirme",
              tooltipField: "namefirme"
            },
            {
              headerName: this.$t("common.gridColumns.summa"),
              headerTooltip: this.$t("common.gridColumns.summa"),
              field: "summa",
              tooltipField: "summa",
              cellClass: "sum-column",
              valueFormatter: params => formatSum(params.value),
              comparator: (sum1, sum2) => sortSum(sum1, sum2)
            },
            {
              headerName: this.$t("common.gridColumns.datebank"),
              headerTooltip: this.$t("common.gridColumns.datebank"),
              field: "datebank",
              tooltipField: "datebank",
              comparator: (date1, date2) =>
                parseInt(this.$moment(date1, "DD.MM.YYYY").unix()) -
                parseInt(this.$moment(date2, "DD.MM.YYYY").unix())
            },
            {
              headerName: this.$t("common.gridColumns.kindname"),
              headerTooltip: this.$t("common.gridColumns.kindname"),
              field: "kindname",
              tooltipField: "kindname"
            },
            {
              headerName: this.$t("common.gridColumns.quantity"),
              headerTooltip: this.$t("common.gridColumns.quantity"),
              field: "quantity",
              tooltipField: "quantity",
              comparator: (value1, value2) =>
                parseInt(value1) - parseInt(value2)
            },
            {
              headerName: this.$t("common.gridColumns.countband"),
              headerTooltip: this.$t("common.gridColumns.countband"),
              field: "countband",
              tooltipField: "countband",
              comparator: (value1, value2) =>
                parseInt(value1) - parseInt(value2)
            },
            {
              headerName: this.$t("common.gridColumns.sumprof"),
              headerTooltip: this.$t("common.gridColumns.sumprof"),
              field: "sumprof",
              tooltipField: "sumprof",
              cellClass: "sum-column",
              valueFormatter: params => formatSum(params.value),
              comparator: (sum1, sum2) => sortSum(sum1, sum2)
            },
            {
              headerName: this.$t("common.gridColumns.statusname"),
              headerTooltip: this.$t("common.gridColumns.statusname"),
              field: "statusname"
            },
            {
              headerName: this.$t("common.gridColumns.statusname"),
              headerTooltip: this.$t("common.gridColumns.statusname"),
              field: "packnumber",
              tooltipField: "packnumber"
            },
            {
              headerName: this.$t("common.gridColumns.sumwithoutprof"),
              headerTooltip: this.$t("common.gridColumns.sumwithoutprof"),
              field: "summawithout",
              tooltipField: "summawithout",
              cellClass: "sum-column",
              valueFormatter: params => formatSum(params.value),
              comparator: (sum1, sum2) => sortSum(sum1, sum2)
            }
          ]
        }
      ],
      packsCountbandColumnDefs: [
        {
          headerName: this.$t(
            "assignoperators.packsCountbandColumn.headers.packsCountband"
          ),
          headerTooltip: this.$t(
            "assignoperators.packsCountbandColumn.headers.packsCountband"
          ),
          children: [
            {
              headerName: this.$t("common.gridColumns.nband"),
              headerTooltip: this.$t("common.gridColumns.nband"),
              field: "nband",
              tooltipField: "nband",
              sort: "asc",
              comparator: (value1, value2) =>
                parseInt(value1) - parseInt(value2)
            },
            {
              headerName: this.$t("common.gridColumns.countpay"),
              headerTooltip: this.$t("common.gridColumns.countpay"),
              field: "countpay",
              tooltipField: "countpay",
              comparator: (value1, value2) =>
                parseInt(value1) - parseInt(value2)
            },
            {
              headerName: this.$t("common.gridColumns.summa"),
              headerTooltip: this.$t("common.gridColumns.summa"),
              field: "summband",
              tooltipField: "summband",
              cellClass: "sum-column",
              valueFormatter: params => formatSum(params.value),
              comparator: (sum1, sum2) => sortSum(sum1, sum2)
            }
          ]
        }
      ],
      packsQuantityColumnDefs: [
        {
          headerName: this.$t(
            "assignoperators.packsQuantityColumn.headers.packsQuantity"
          ),
          headerTooltip: this.$t(
            "assignoperators.packsQuantityColumn.headers.packsQuantity"
          ),
          children: [
            {
              headerName: this.$t("common.gridColumns.abcodeNumber"),
              headerTooltip: this.$t("common.gridColumns.abcodeNumber"),
              field: "abcode",
              tooltipField: "abcode"
            },
            {
              headerName: this.$t("common.gridColumns.summa"),
              headerTooltip: this.$t("common.gridColumns.summa"),
              field: "summpay",
              tooltipField: "summpay",
              cellClass: "sum-column",
              valueFormatter: params => formatSum(params.value),
              comparator: (sum1, sum2) => sortSum(sum1, sum2)
            },
            {
              headerName: this.$t("common.gridColumns.datepay"),
              headerTooltip: this.$t("common.gridColumns.datepay"),
              field: "dateclient",
              tooltipField: "dateclient",
              comparator: (date1, date2) =>
                parseInt(this.$moment(date1, "DD.MM.YYYY").unix()) -
                parseInt(this.$moment(date2, "DD.MM.YYYY").unix())
            },
            {
              headerName: this.$t("common.gridColumns.nameplat"),
              headerTooltip: this.$t("common.gridColumns.nameplat"),
              field: "nameplat",
              tooltipField: "nameplat"
            },
            {
              headerName: this.$t("common.gridColumns.fio"),
              headerTooltip: this.$t("common.gridColumns.fio"),
              field: "fio",
              tooltipField: "fio"
            },
            {
              headerName: this.$t("common.gridColumns.adress"),
              headerTooltip: this.$t("common.gridColumns.adress"),
              field: "adress",
              tooltipField: "adress"
            }
          ]
        }
      ],
      money: {
        decimal: ".",
        thousands: "",
        precision: 2
      },
      operatorForm: {
        userCodeCode: null,
        userCode: null,
        workedEnabled: false,
        workedDate: this.$moment().format("DD.MM.YYYY"),
        positionEnabled: false,
        positionCode: null
      },
      assignBtnDisabled: true,
      unassignBtnDisabled: true,
      receiptsBtnDisabled: true,
      infoPackReceiptsBtnDisabled: true,
      infoPackReceiptsBtnContainer: null,
      currentFreePacksRowSelected: null,
      currentAssignedPacksRowSelected: null,
      currentPacksCountbandRowSelected: null,
      currentPacksQuantityRowSelected: null,
      receiptsModal: false,
      receiptsForm: {
        summa: null,
        datebank: null,
        quantity: null,
        countband: null,
        reasonname: null
      },
      assignModal: false,
      unassignModal: false
    };
  },
  computed: {
    ...mapGetters([
      "operators",
      "operatorsLoading",
      "freePacks",
      "assignedPacks",
      "packsCountband",
      "packsQuantity",
      "statusLinkPack",
      "statusInfoPack",
      "initPage",
      "params"
    ]),
    checkAllModal: function() {
      return !this.receiptsModal && !this.assignModal && !this.unassignModal;
    }
  },
  watch: {
    "operatorForm.userCode": function(puserid) {
      this.operatorForm.userCodeCode = +puserid || null;
      const msg = this.$t("assignoperators.operatorForm.userCode.msg");
      if (puserid) {
        //this.assignBtnDisabled = this.unassignBtnDisabled = this.receiptsBtnDisabled = false;
        const rowCount = this.freePacksGridOptions.api.getDisplayedRowCount();
        this.assignBtnDisabled =
          rowCount === 0 || this.operatorForm.userCode === null ? true : false;

        if (this.assignedPacksGridOptions.api) {
          this.assignedPacksGridOptions.api.setRowData([]);
          this.assignedPacksGridOptions.api.showLoadingOverlay();
        }
        this.$store.dispatch("getAssignedPacks", { puserid });

        this.assignedPacksColumnDefs[0].headerName = this.assignedPacksColumnDefs[0].headerTooltip = `${msg} ${userName(
          this.params.gusers.data,
          puserid
        )}`;
        this.assignedPacksGridOptions.api.setColumnDefs(
          this.assignedPacksColumnDefs
        );
        this.assignedPacksGridOptions.api.sizeColumnsToFit();
      } else {
        //this.assignBtnDisabled = this.unassignBtnDisabled = this.receiptsBtnDisabled = true;
        this.$store.commit("clearAssignedPacks");
        this.assignedPacksColumnDefs[0].headerName = this.assignedPacksColumnDefs[0].headerTooltip = msg;
        this.assignedPacksGridOptions.api.setColumnDefs(
          this.assignedPacksColumnDefs
        );
      }
    },
    "operatorForm.workedEnabled": function() {
      this.getOperators();
    },
    "operatorForm.workedDate": function() {
      this.getOperators();
    },
    "operatorForm.positionEnabled": function() {
      this.getOperators();
    },
    "operatorForm.positionCode": function() {
      this.getOperators();
    },
    statusInfoPack: function(npack) {
      if (npack) {
        const message = `${this.$t(
          "assignoperators.statusInfoPack.pack"
        )} №${npack} ${this.$t("assignoperators.statusInfoPack.wasPosting")}`;
        this.$alert(message, this.$t("assignoperators.statusInfoPack.title"), {
          confirmButtonText: this.$t("common.buttons.confirmOk"),
          callback: () => {
            this.receiptsModal = false;
            const puserid = this.operatorForm.userCode;

            if (this.assignedPacksGridOptions.api) {
              this.assignedPacksGridOptions.api.setRowData([]);
              this.assignedPacksGridOptions.api.showLoadingOverlay();
            }
            this.$store.dispatch("getAssignedPacks", { puserid });
          }
        });
      }
    },
    statusLinkPack: function(puserid) {
      if (puserid) {
        if (this.freePacksGridOptions.api) {
          this.freePacksGridOptions.api.setRowData([]);
          this.freePacksGridOptions.api.showLoadingOverlay();
        }
        this.$store.dispatch("getFreePacks");

        if (this.assignedPacksGridOptions.api) {
          this.assignedPacksGridOptions.api.setRowData([]);
          this.assignedPacksGridOptions.api.showLoadingOverlay();
        }
        this.$store.dispatch("getAssignedPacks", { puserid });
      }
    }
  },
  beforeCreate() {
    if (!checkAccess(76)) {
      this.$router.push("/");
    }
  },
  created() {
    document.title = this.$t("assignoperators.title");
    this.getParams({
      gfirme: "1",
      gkindpay: "1",
      gusers: "1",
      position: "1",
      codepay: "1",
      codereason: "1"
    });
  },
  beforeMount() {
    const locale = i18n.locale;
    switch (locale) {
      case "ru":
        this.agGridlocaleText = agGridLocaleRu;
        break;
      case "ua":
        this.agGridlocaleText = agGridLocaleUa;
        break;
      case "en":
        this.agGridlocaleText = agGridLocaleEn;
        break;
      default:
        this.agGridlocaleText = agGridLocaleRu;
    }

    this.freePacksGridOptions = {
      suppressCellSelection: true,
      preventDefaultOnContextMenu: true,
      localeText: this.agGridlocaleText
    };

    this.assignedPacksGridOptions = {
      suppressCellSelection: true,
      preventDefaultOnContextMenu: true,
      localeText: this.agGridlocaleText
    };

    this.packsCountbandGridOptions = {
      suppressCellSelection: true,
      preventDefaultOnContextMenu: true,
      localeText: this.agGridlocaleText
    };

    this.packsQuantityGridOptions = {
      suppressCellSelection: true,
      preventDefaultOnContextMenu: true,
      localeText: this.agGridlocaleText
    };

    this.packsGetRowStyle = params => {
      if (params.node.rowPinned) return { "font-weight": "bold" };
    };
  },
  mounted() {
    this.getOperators();
  },
  beforeDestroy() {
    this.$store.commit("setParams", null);
    this.$store.commit("setOperators", []);
    this.$store.commit("clearFreePacks");
    this.$store.commit("clearAssignedPacks");
    this.$store.commit("clearPacksCountband");
    this.$store.commit("clearPacksQuantity");
    this.$store.commit("clearStatusLinkPack");
    this.$store.commit("clearStatusInfoPack");
  },
  methods: {
    ...mapActions(["getParams"]),
    assignBtn() {
      this.assignModal = true;
      this.$confirm(
        `${this.$t(
          "assignoperators.assignBtn.confirm.assignOperator"
        )} ${userName(
          this.params.gusers.data,
          this.operatorForm.userCode
        )} ${this.$t("assignoperators.assignBtn.confirm.toWorkWithPack")}?`,
        this.$t("assignoperators.assignBtn.confirm.title"),
        {
          confirmButtonText: this.$t("common.buttons.confirmYes"),
          cancelButtonText: this.$t("common.buttons.confirmNo"),
          cancelButtonClass: "cancel-button",
          type: "info"
        }
      )
        .then(() => {
          this.assignModal = false;
          const { npack } = this.currentFreePacksRowSelected;
          const userid = this.operatorForm.userCode;

          this.$store.commit("clearStatusLinkPack");
          this.$store.dispatch("assignPack", { npack, userid });
        })
        .catch(() => {
          this.assignModal = false;
        });
    },
    unassignBtn() {
      this.unassignModal = true;
      this.$confirm(
        `${this.$t(
          "assignoperators.unassignBtn.confirm.unassignOperator"
        )} ${userName(
          this.params.gusers.data,
          this.operatorForm.userCode
        )} ${this.$t("assignoperators.unassignBtn.confirm.fromWorkWithPack")}?`,
        this.$t("assignoperators.unassignBtn.confirm.title"),
        {
          confirmButtonText: this.$t("common.buttons.confirmYes"),
          cancelButtonText: this.$t("common.buttons.confirmNo"),
          cancelButtonClass: "cancel-button",
          type: "info"
        }
      )
        .then(() => {
          this.unassignModal = false;
          const { npack } = this.currentAssignedPacksRowSelected;
          const userid = this.operatorForm.userCode;

          this.$store.commit("clearStatusLinkPack");
          this.$store.dispatch("unassignPack", { npack, userid });
        })
        .catch(() => {
          this.unassignModal = false;
        });
    },
    receiptsBtn() {
      this.receiptsModal = true;
    },
    getOperators() {
      this.operatorForm.userCode = null;
      const {
        workedEnabled,
        workedDate,
        positionEnabled,
        positionCode
      } = this.operatorForm;
      this.$store.dispatch("getOperators", {
        workedEnabled,
        workedDate,
        positionEnabled,
        positionCode
      });
    },
    onGridSizeChanged(params) {
      // params.api.sizeColumnsToFit();
    },
    onFreePacksGridReady(params) {
      this.freePacksGridApi = params.api;
      this.freePacksColumnApi = params.columnApi;

      params.api.setRowData([]);
      params.api.showLoadingOverlay();
      this.$store.dispatch("getFreePacks");
    },
    onFreePacksFirstDataRendered(event) {
      setGridView("wb-assignoperators-grid-freepacks", event, "optimal");
    },
    onFreePacksRowRightClicked(event) {
      this.$store.commit(
        "setGridContextMenuKey",
        "wb-assignoperators-grid-freepacks"
      );
      this.$store.commit("setGridContextMenuEvent", event);
      this.$store.commit("setGridContextMenuModal", true);
    },
    onFreePacksModelUpdated(params) {
      const rowCount = params.api.getDisplayedRowCount();
      this.assignBtnDisabled =
        rowCount === 0 || this.operatorForm.userCode === null ? true : false;

      params.api.forEachNode(node =>
        node.rowIndex ? 0 : node.setSelected(true)
      );
    },
    onFreePacksRowSelected(params) {
      if (params.node.selected) {
        this.currentFreePacksRowSelected = params.node.data;
      }
    },
    onAssignedPacksGridReady(params) {
      this.assignedPacksGridApi = params.api;
      this.assignedPacksColumnApi = params.columnApi;
    },
    onAssignedPacksFirstDataRendered(event) {
      setGridView("wb-assignoperators-grid-assignedpacks", event, "optimal");
    },
    onAssignedPacksRowRightClicked(event) {
      this.$store.commit(
        "setGridContextMenuKey",
        "wb-assignoperators-grid-assignedpacks"
      );
      this.$store.commit("setGridContextMenuEvent", event);
      this.$store.commit("setGridContextMenuModal", true);
    },
    onAssignedPacksModelUpdated(params) {
      const rowCount = params.api.getDisplayedRowCount();
      this.unassignBtnDisabled = this.receiptsBtnDisabled =
        rowCount === 0 ? true : false;

      params.api.forEachNode(node =>
        node.rowIndex ? 0 : node.setSelected(true)
      );
    },
    onAssignedPacksRowSelected(params) {
      if (params.node.selected) {
        this.currentAssignedPacksRowSelected = params.node.data;
      }
    },
    onPacksCountbandGridReady(params) {
      this.packsCountbandGridApi = params.api;
      this.packsCountbandColumnApi = params.columnApi;
    },
    onPacksCountbandFirstDataRendered(event) {
      setGridView("wb-assignoperators-grid-packscountband", event, "optimal");
    },
    onPacksCountbandRowRightClicked(event) {
      this.$store.commit(
        "setGridContextMenuKey",
        "wb-assignoperators-grid-packscountband"
      );
      this.$store.commit("setGridContextMenuEvent", event);
      this.$store.commit("setGridContextMenuModal", true);
    },
    onPacksCountbandModelUpdated(params) {
      const rowCount = params.api.getDisplayedRowCount();

      params.api.forEachNode(node =>
        node.rowIndex ? 0 : node.setSelected(true)
      );

      let pinnedRowCountpay = 0;
      let pinnedRowSummband = 0;

      for (let i = 0; i < rowCount; i++) {
        let rowNode = params.api.getDisplayedRowAtIndex(i);
        pinnedRowCountpay = $(pinnedRowCountpay)
          .add($(rowNode.data.countpay))
          .toNumber();
        pinnedRowSummband = $(pinnedRowSummband)
          .add($(rowNode.data.summband))
          .toNumber();
      }
      const pinnedRowCountpayEq = pinnedRowCountpay.toString();
      const pinnedRowSummbandEq = $(pinnedRowSummband).toFixed();
      const receiptsFormSumma = $(this.receiptsForm.summa).toFixed();
      pinnedRowSummband = formatSum(pinnedRowSummbandEq);

      try {
        this.packsCountbandPinnedBottomRowData = [
          {
            nband: "",
            countpay: pinnedRowCountpay,
            summband: pinnedRowSummband
          }
        ];

        if (rowCount === 0) {
          this.infoPackReceiptsBtnDisabled = true;
        } else {
          this.infoPackReceiptsBtnDisabled =
            this.receiptsForm.quantity === pinnedRowCountpayEq &&
            receiptsFormSumma === pinnedRowSummbandEq
              ? false
              : true;
        }
      } catch {
        this.packsCountbandPinnedBottomRowData = [
          {
            nband: "",
            countpay: "0",
            summband: "0.00"
          }
        ];

        this.infoPackReceiptsBtnDisabled = true;
      }
    },
    onPacksCountbandRowSelected(params) {
      if (params.node.selected) {
        this.currentPacksCountbandRowSelected = params.node.data;

        const { npack } = this.currentAssignedPacksRowSelected;
        const { nband } = this.currentPacksCountbandRowSelected;

        if (this.packsQuantityGridOptions.api) {
          this.packsQuantityGridOptions.api.setRowData([]);
          this.packsQuantityGridOptions.api.showLoadingOverlay();
        }
        this.$store.dispatch("getPacksQuantity", { npack, nband });
      }
    },
    onPacksQuantityGridReady(params) {
      this.packsQuantityGridApi = params.api;
      this.packsQuantityColumnApi = params.columnApi;
    },
    onPacksQuantityFirstDataRendered(event) {
      setGridView("wb-assignoperators-grid-packsquantity", event, "optimal");
    },
    onPacksQuantityRowRightClicked(event) {
      this.$store.commit(
        "setGridContextMenuKey",
        "wb-assignoperators-grid-packsquantity"
      );
      this.$store.commit("setGridContextMenuEvent", event);
      this.$store.commit("setGridContextMenuModal", true);
    },
    onPacksQuantityModelUpdated(params) {
      params.api.forEachNode(node =>
        node.rowIndex ? 0 : node.setSelected(true)
      );

      const pinnedRowCount = params.api.getDisplayedRowCount();
      let pinnedRowSummpay = 0;
      for (let i = 0; i < pinnedRowCount; i++) {
        let rowNode = params.api.getDisplayedRowAtIndex(i);
        pinnedRowSummpay = $(pinnedRowSummpay)
          .add($(rowNode.data.summpay))
          .toNumber();
      }
      pinnedRowSummpay = formatSum($(pinnedRowSummpay).toFixed());

      try {
        this.packsQuantityPinnedBottomRowData = [
          {
            abcode: pinnedRowCount,
            summpay: pinnedRowSummpay,
            dateclient: "",
            codeplat: "",
            fio: "",
            adress: ""
          }
        ];
      } catch {
        this.packsQuantityPinnedBottomRowData = [
          {
            abcode: "0",
            summpay: "0.00",
            dateclient: "",
            codeplat: "",
            fio: "",
            adress: ""
          }
        ];
      }
    },
    onPacksQuantityRowSelected(params) {
      if (params.node.selected) {
        this.currentPacksQuantityRowSelected = params.node.data;
      }
    },
    receiptsModalShow() {
      const {
        kindpay,
        npack,
        paysheetid,
        summa,
        datebank,
        quantity,
        countband,
        codereason
      } = this.currentAssignedPacksRowSelected;

      this.receiptsForm = {
        summa: $(summa).toNumber(),
        datebank,
        quantity,
        countband,
        reasonname: reasonName(this.params.codereason.data, codereason)
      };

      this.infoPackReceiptsBtnContainer =
        paysheetid || ["41", "99", "100"].includes(kindpay) ? true : false;

      if (this.packsCountbandGridOptions.api) {
        this.packsCountbandGridOptions.api.setRowData([]);
        this.packsCountbandGridOptions.api.showLoadingOverlay();
      }
      this.$store.dispatch("getPacksCountband", { npack });
    },
    receiptsModalHide() {
      this.receiptsForm = {
        summa: null,
        datebank: null,
        quantity: null,
        countband: null,
        reasonname: null
      };
      this.infoPackReceiptsBtnContainer = null;

      this.$store.commit("clearPacksCountband");
      this.$store.commit("clearPacksQuantity");
    },
    receiptsModalSubmit() {
      let { npack } = this.currentAssignedPacksRowSelected;
      npack = npack.trim();

      this.$store.commit("clearStatusInfoPack");
      this.$store.dispatch("receiptsInfoPack", { npack });
    },
    onChangeUserCodeCode(event) {
      const value = event.target.value;
      const users = this.operators.data.filter(item => item.userid === value);
      if (users.length > 0) {
        this.operatorForm.userCode = value;
      } else {
        this.operatorForm.userCode = null;
        this.operatorForm.userCodeCode = null;
      }
    },
    onShortKeyRouter(event) {
      switch (event.srcKey) {
        case "Enter":
          // receipts
          if (this.checkAllModal && !this.receiptsBtnDisabled) {
            this.receiptsBtn();
          }
          break;
        case "F9":
          // receipts
          if (this.checkAllModal && !this.receiptsBtnDisabled) {
            this.receiptsBtn();
          }
          //receipts: receiptsModal
          else if (
            this.receiptsModal &&
            this.infoPackReceiptsBtnContainer &&
            !this.infoPackReceiptsBtnDisabled
          ) {
            this.receiptsModalSubmit();
          }
          break;
        case "Insert":
        case "Plus":
          // assign
          if (this.checkAllModal && !this.assignBtnDisabled) {
            this.assignBtn();
          }
          break;
        case "Del":
        case "Minus":
          // unassign
          if (this.checkAllModal && !this.unassignBtnDisabled) {
            this.unassignBtn();
          }
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.grid-container-operators {
  margin-top: 10px;
  height: calc(50vh - 115px);
  overflow-y: auto;
}

.grid-container-modalinfopacks {
  margin-top: 10px;
  height: calc(50vh);
  overflow-y: auto;
}

.moneydisable {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #c0c4cc;
  cursor: not-allowed;
  &:hover {
    border-color: #e4e7ed;
  }
}
</style>
